











import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component({})
export default class ProgressConponent extends Vue {
  @Prop({ type: Number, default: 0 }) value!: number;
  @Prop({ type: String, default: "primary" }) variant!: string;

  progressValue = `${this.value.toFixed(2)}%`;

  @Watch("value")
  updateValue(): void {
    if (this.value != 0) {
      this.progressValue = `${this.value.toFixed(2)}%`;
    } else {
      this.progressValue = "Error";
    }
  }
}
